<div [class.container]="isVerticalLayout$ | async" class="toolbar w-full px-gutter flex items-center">

  <button (click)="openSidenav()" [class.hidden]="!mobileQuery" mat-icon-button type="button">
    <mat-icon svgIcon="mat:menu"></mat-icon>
  </button>


  <button (click)="toggleCollapse()"
          *ngIf="showCollapsePin$ | async"
          class="w-8 h-8 p-0 -ml-3 leading-none flex-none hidden lg:block"
          mat-icon-button
          type="button">
    @if(!collapsed) {
      <mat-icon class="text-[0.875rem] w-[0.875rem] h-[0.875rem]" svgIcon="mat:radio_button_checked"></mat-icon>
    } @else {
      <mat-icon class="text-[0.875rem] w-[0.875rem] h-[0.875rem]" svgIcon="mat:radio_button_unchecked"></mat-icon>
    }
  </button>

  @if (owners.length > 0) {
    <button mat-stroked-button
            type="button"
            [matMenuTriggerFor]="ownerMenu"
            class="owner-switcher-trigger"
            aria-label="Přepnout vlastníka">
      <span class="owner-logo owner-logo--trigger" aria-hidden="true">
        @if (ownerLogoUrl(currentOwner); as logoUrl) {
          <img [src]="logoUrl" alt="">
        } @else {
          <span>{{ ownerInitials(currentOwner) }}</span>
        }
      </span>
      <span class="owner-trigger-copy">
        <span class="owner-trigger-label">Vlastník</span>
        <span class="owner-trigger-name">{{ currentOwner?.name || ('Vlastník ' + authService.currentOwnerId) }}</span>
      </span>
      <mat-icon class="owner-trigger-chevron" svgIcon="mat:expand_more"></mat-icon>
    </button>
    <mat-menu #ownerMenu="matMenu" class="owner-menu" xPosition="after" [overlapTrigger]="false">
      <div class="owner-menu-heading" role="presentation">
        <span class="owner-menu-eyebrow">Pracovní prostor</span>
        <span class="owner-menu-title">Přepnout vlastníka</span>
      </div>
      @for (owner of owners; track owner.id) {
        <button mat-menu-item
                type="button"
                class="owner-menu-item"
                [class.owner-menu-item--active]="owner.id === authService.currentOwnerId"
                [attr.aria-label]="owner.name + (owner.id === authService.currentOwnerId ? ', aktuálně vybráno' : '')"
                (click)="selectOwner(owner.id)">
          <span class="owner-logo" aria-hidden="true">
            @if (ownerLogoUrl(owner); as logoUrl) {
              <img [src]="logoUrl" alt="">
            } @else {
              <span>{{ ownerInitials(owner) }}</span>
            }
          </span>
          <span class="owner-menu-copy">
            <span class="owner-menu-name">{{ owner.name }}</span>
            <span class="owner-menu-meta">{{ owner.shortcut }}</span>
          </span>
          @if (owner.id === authService.currentOwnerId) {
            <span class="owner-active-badge">
              <mat-icon svgIcon="mat:check"></mat-icon>
              Aktivní
            </span>
          }
        </button>
      }
    </mat-menu>
  }

<!--  <a *ngIf="isVerticalLayout$ | async"-->
<!--     [routerLink]="['/']"-->
<!--     class="ltr:mr-4 rtl:ml-4 block flex items-center">-->
<!--    <img alt="Logo" class="w-8 select-none" src="assets/img/demo/logo.svg"/>-->
<!--    <h1 [class.hidden]="!mobileQuery" class="title ltr:pl-4 rtl:pr-4 m-0 select-none">VEX</h1>-->
<!--  </a>-->

<!--  <button *ngIf="isHorizontalLayout$ | async"-->
<!--          [class.hidden]="mobileQuery"-->
<!--          [matMenuTriggerFor]="addNewMenu"-->
<!--          color="primary"-->
<!--          mat-flat-button-->
<!--          type="button">Add New-->
<!--  </button>-->

<!--  <mat-menu #addNewMenu="matMenu" [overlapTrigger]="false" xPosition="after" yPosition="below">-->
<!--    <button mat-menu-item>-->
<!--      <mat-icon svgIcon="mat:person_add"></mat-icon>-->
<!--      <span>Add Contact</span>-->
<!--    </button>-->

<!--    <button mat-menu-item>-->
<!--      <mat-icon svgIcon="mat:done_all"></mat-icon>-->
<!--      <span>Add Task</span>-->
<!--    </button>-->

<!--    <button mat-menu-item>-->
<!--      <mat-icon svgIcon="mat:assignment_turned_in"></mat-icon>-->
<!--      <span>Add Project</span>-->
<!--    </button>-->

<!--    <button [matMenuTriggerFor]="documentMenu" mat-menu-item>-->
<!--      <mat-icon svgIcon="mat:ballot"></mat-icon>-->
<!--      <span>Add Document</span>-->
<!--    </button>-->
<!--  </mat-menu>-->

<!--  <mat-menu #documentMenu="matMenu">-->
<!--    <button mat-menu-item>-->
<!--      <mat-icon svgIcon="mat:description"></mat-icon>-->
<!--      <span>Add Quote</span>-->
<!--    </button>-->

<!--    <button mat-menu-item>-->
<!--      <mat-icon svgIcon="mat:assignment"></mat-icon>-->
<!--      <span>Add Invoice</span>-->
<!--    </button>-->

<!--    <button mat-menu-item>-->
<!--      <mat-icon svgIcon="mat:receipt"></mat-icon>-->
<!--      <span>Add Receipt</span>-->
<!--    </button>-->
<!--  </mat-menu>-->

<!--  <div #megaMenuOriginRef class="ltr:ml-2 rtl:mr-2">-->
<!--    <button *ngIf="isHorizontalLayout$ | async"-->
<!--            [class.hidden]="mobileQuery"-->
<!--            (click)="openMegaMenu(megaMenuOriginRef)"-->
<!--            [ngClass]="{ 'bg-primary/10': megaMenuOpen$ | async }"-->
<!--            color="primary"-->
<!--            mat-button-->
<!--            type="button">-->
<!--      <span>Mega Menu</span>-->
<!--      <mat-icon class="icon-sm" svgIcon="mat:arrow_drop_down"></mat-icon>-->
<!--    </button>-->
<!--  </div>-->


  @if((isVerticalLayout$ | async) && isNavbarInToolbar$ | async) {
    <div [class.hidden]="mobileQuery" class="px-gutter flex-none flex items-center">
      <vex-navigation-item *ngFor="let item of navigationItems" [item]="item"></vex-navigation-item>
    </div>
  }


  <span class="flex-1"></span>

  <div class="-mx-1 flex items-center">
    <span class="environment-badge" [attr.aria-label]="'Prostředí: ' + envName">
      <span class="environment-badge-dot" aria-hidden="true"></span>
      {{ envName }}
    </span>
<!--    <div class="px-1">-->
<!--      <button (click)="openSearch()" mat-icon-button type="button">-->
<!--        <mat-icon color="primary" svgIcon="mat:search"></mat-icon>-->
<!--      </button>-->
<!--    </div>-->



<!--    <div class="px-1">-->
<!--      <button (click)="openQuickpanel()" mat-icon-button type="button">-->
<!--        <mat-icon color="primary" svgIcon="mat:bookmarks"></mat-icon>-->
<!--      </button>-->
<!--    </div>-->

<!--    <div class="px-1">-->
<!--      <button [matMenuTriggerFor]="languageMenu" mat-icon-button type="button">-->
<!--        <mat-icon svgIcon="flag:united-states"></mat-icon>-->
<!--      </button>-->
<!--    </div>-->

    @if(userVisible$ | async) {
      <div class="px-1">
        <vex-toolbar-user></vex-toolbar-user>
      </div>
    }


<!--    <div class="px-1">-->
<!--      <vex-toolbar-notifications></vex-toolbar-notifications>-->
<!--    </div>-->

    @if(environment.name !== 'PROD') {
      <div class="px-1">
        <button mat-icon-button color="primary" matTooltip="App ToolKit" (click)="openToolkitModal()">
          <mat-icon svgIcon="mat:build_circle"></mat-icon>
        </button>
      </div>
    }
  </div>
</div>

@if((isVerticalLayout$ | async) && isNavbarBelowToolbar$ | async) {
  <vex-navigation [class.hidden]="mobileQuery"></vex-navigation>
}
